import { NoteDataSourceEnum } from '@eigtech/notes-types'
import { startCase } from 'lodash-es'

const noteDataSourceLabels: Partial<Record<NoteDataSourceEnum, string>> = {
  Meetings: 'Inspections',
  CPAP: 'CPAP',
  CSR: 'CSR',
  TPLAP: 'TPLAP',
}

export const getNoteDataSourceLabel = (dataSource: NoteDataSourceEnum) =>
  noteDataSourceLabels[dataSource] ?? startCase(dataSource)
